var exports = {
  "zr": "root__fah1eN",
  "JP": "embeddedRoot__N7qL3v",
  "kL": "container__v4Vw9d",
  "qr": "footer__QYeNl8",
};

module.exports = exports;
